import { i18nFilter } from "app/filters/i18nFilter";
import type { FC } from "react";
import { Dropdown, EllipsisDropdownItem } from "@similarweb/ui-components";
import { SWReactIcons } from "@similarweb/icons";
import styled from "styled-components";
import categoryService from "app/common/services/categoryService";

interface IEditContextMenu {
    onEdit: VoidFunction;
    onDelete: VoidFunction;
    onShare: VoidFunction;
    onToggle: (isOpen: boolean) => void;
}

const IconContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`;

export const EditContextMenu: FC<IEditContextMenu> = (props) => {
    const { onEdit, onDelete, onToggle, onShare } = props;

    const contextMenuOptions = [
        {
            id: "edit",
            iconName: "edit-icon",
            iconSize: "sm",
            text: i18nFilter()("common.edit"),
            onClickFunc: onEdit,
        },
        {
            id: "delete",
            iconName: "delete",
            iconSize: "sm",
            text: i18nFilter()("common.delete"),
            onClickFunc: onDelete,
        },
    ];

    if (categoryService.hasSmartSharingPermission()) {
        contextMenuOptions.splice(1, 0, {
            id: "share",
            iconName: "social-share",
            iconSize: "sm",
            text: i18nFilter()("common.share"),
            onClickFunc: onShare,
        });
    }

    const contextMenuItems = [
        <IconContainer key={"settings"}>
            <SWReactIcons
                iconName="dots-more"
                size="sm"
            />
        </IconContainer>,
        ...contextMenuOptions,
    ];

    return (
        <Dropdown
            dropdownPopupPlacement="bottom-left"
            buttonWidth="40px"
            width="180px"
            itemsComponent={EllipsisDropdownItem}
            onClick={(action) => action.onClickFunc(action.id)}
            onToggle={onToggle}
        >
            {contextMenuItems}
        </Dropdown>
    );
};
